import React from "react";
import ASTRA_REAL_SRC from "@/assets/astra/astraReal";
import ORION_REAL_SRC from "@/assets/orion/orion-premium.webp";

export const AionHolographicFace = ({ profile = "female", expression = "calm" }) => {
  const resolvedProfile = profile === "male" ? "male" : "female";
  const name = resolvedProfile === "male" ? "ORION" : "ASTRA";
  return (
    <div
      className={`aion-real-avatar-shell aion-holographic-face aion-holographic-face-${resolvedProfile}`}
      data-profile={resolvedProfile}
      data-expression={expression}
      data-animation-mode="portrait"
    >
      <img className="aion-real-avatar-image" src={resolvedProfile === "male" ? ORION_REAL_SRC : ASTRA_REAL_SRC} alt={`AION ${name}`} />
      <span className="aion-real-avatar-halo" aria-hidden="true" />
      <span className="aion-real-avatar-voice-pulse" aria-hidden="true" />
      <span className="aion-real-avatar-label">{name}</span>
    </div>
  );
};
